export enum HttpStatus {
    SUCCESS = 200,
    NOT_FOUND = 404,
    UNAUTHORIZED = 401,
    NOT_ACCEPTABLE = 406,
    EXCEPTION = 417,
    ERROR = 500
}
